// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#rootVM[data-v-25d3c9d2] {\r\n\twidth: 100%;\r\n\theight: 100vh;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\n}\n#rootVM i[data-v-25d3c9d2] {\r\n\tfont-size: 3em;\r\n\tmargin: auto;\n}\r\n", ""]);
// Exports
module.exports = exports;
